import { render, staticRenderFns } from "./CreateNamespaces.vue?vue&type=template&id=61d550a6"
import script from "./CreateNamespaces.vue?vue&type=script&lang=js"
export * from "./CreateNamespaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports